import React from 'react';
import PropTypes from 'prop-types';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';

import styles from './PlansCard.module.css';

import BasicPlanImage from './../../assets/images/plan_basic.svg';
import PremiumPlanImage from './../../assets/images/plan_premium.svg';

function PlansCard({
  id,
  title,
  description,
  monthlyPrice,
  onClick,
  active,
  expiresIn,
  observations,
  isTrial,
  yearlyPriceInstallments,
}) {
  const [remainingTime, setTime] = React.useState();
  const [startCountdown, setCountdown] = React.useState(false);
  // const value = monthlyPrice.toFixed(2).replace('.', ',');

  const formatValue = value => value !== null && value.toFixed(2).replace('.', ',');

  React.useEffect(() => {
    if (remainingTime && startCountdown) {
      setTimeout(() => {
        if (remainingTime !== '00:00:00') {
          setTime(moment(remainingTime, 'HH:mm:ss').subtract(1, 'second').format('HH:mm:ss'));
        } else {
          document.location.reload();
        }
      }, 1000);
    }
  }, [remainingTime, startCountdown]);

  React.useEffect(() => {
    if (expiresIn) {
      if (!isTrial) {
        setCountdown(false);
        setTime(expiresIn);
      }

      // const expireDate = moment().add(1, 'minute'); // simula 1 hora para expirar o plano
      // const expireDate = moment().add(1, 'day'); // simula 1 dia para expirar o plano
      // const expireDate = moment().add(1, 'day').add(1, 'minute'); // simula 1 dia e 1 hora
      const expireDate = moment(expiresIn, 'DD/MM/YYYY HH:mm:ss'); // Pega a data de expiração normal.
      const now = moment();
      const timeDiff = expireDate.diff(now, 'days');
      const timeDiffHours = expireDate.diff(now, 'hours');
      const text = timeDiff > 1 ? 'dias' : 'dia';

      if (timeDiff > 0 && timeDiffHours >= 24) {
        setCountdown(false);
        setTime(`${timeDiff + (timeDiffHours <= 48 ? 1 : 0)} ${text}${timeDiffHours <= 48 ? 's' : ''}`);
      } else {
        setTime(`${moment.utc(expireDate.diff(now, 'milliseconds')).format('HH:mm:ss')}`);
        setCountdown(true);
      }
    }
  }, [isTrial, expiresIn]);

  return (
    <div className={[styles.card]}>
      <Card>
        <CardContent>

          <div style={{ padding: '8px 20px 0' }}>
            <div className={styles.titleContainer}>
              <Typography variant="h6" component="h6" style={{ margin: 0 }}>
                {title}
              </Typography>

              {
                active && (
                  <Chip
                    size="small"
                    label={isTrial ? 'Avaliação' : 'Ativo'}
                    className={styles.currentChip}
                    style={{ color: 'white', backgroundColor: isTrial ? '#FF6464' : '#00D279' }}
                  />
                )
              }
            </div>

            <div style={{ textAlign: 'center' }}>
              {id === 11 && <img src={BasicPlanImage} alt="Imagem Plano Básico" />}
              {id === 13 && <img src={PremiumPlanImage} alt="Imagem Plano Premium" />}
            </div>

            <Typography variant="h2" style={{ margin: '0.75em 0', fontSize: '2.25rem' }}>
              R$ {formatValue(id === 13 ? monthlyPrice : yearlyPriceInstallments)}
              <Typography inline variant="h5" component="span">
                /mês
              </Typography>
            </Typography>

            <div style={{ marginBottom: '1.25em' }}>
              {
                description && description.map(content => (
                  <Typography variant='body2' key={content} gutterBottom className={styles.descriptionItem}>
                    <CheckIcon />
                    {
                      content === 'Funcionalidades básicas' ?
                        <a href="https://puntu.digital/#how-works" rel="noopener noreferrer" target="_blank">{content}</a> :
                        content
                    }
                  </Typography>
                ))
              }
            </div>

            <Typography
              variant="subtitle2"
              align="center"
              style={{ opacity: active && monthlyPrice !== 0 ? 1 : 0, color: isTrial ? '#FF6464' : '#00D279', marginBottom: '0.25em', fontSize: '0.75rem', fontWeight: 'bold' }}
            >
              {isTrial ? 'Expira em ' : 'Ativo até '}
              <Typography inline variant="caption" style={{ fontWeight: 'bold', color: isTrial ? '#FF6464' : '#00D279' }}>
                {isTrial ? remainingTime : expiresIn}
              </Typography>
            </Typography>

            <Button
              variant="contained"
              fullWidth
              color="primary"
              onClick={onClick}
              className={styles.buyButton}
              disabled={monthlyPrice === 0}
              style={{
                opacity: monthlyPrice === 0 ? 0 : 1,
                cursor: monthlyPrice === 0 ? 'unset' : 'pointer',
              }}
            >
              COMPRAR
            </Button>

          </div>
        </CardContent>
      </Card>
      <Typography inline variant="caption">
        {observations && `* ${observations}`}
      </Typography>
    </div>
  );
}

PlansCard.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.array.isRequired,
  monthlyPrice: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  expiresIn: PropTypes.string.isRequired,
  observations: PropTypes.string.isRequired,
};

export default PlansCard;
